import { Box } from "@mui/material";

// Small uppercase Black Ops One label used as a section/card eyebrow inside the
// /tilaa wizard surfaces (m³ hero card, Avustimen tulos card, SpecGuideResult).
// Defaults match the most common usage (11px / 0.16em); override via `sx` for
// the one-off larger m³ eyebrow.
export default function WizardEyebrow({ color, children, sx }) {
    return (
        <Box
            component="span"
            sx={{
                display: "block",
                fontFamily: "'Black Ops One', serif",
                fontSize: 11,
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                color,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}
